import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ligas.css';
import { ligas_item } from '../../json/ligasitems';

const Ligas = () => {
  const [expandedItem, setExpandedItem] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleItem = (name) => {
    setExpandedItem((prev) => (prev === name ? null : name));
  };

  return (
    <div className='container ligas-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <div className='ligas_title'>
            <h1>Ligas de Interés</h1>
            <br></br>
            <hr className='hr-gob'></hr>
          </div>
        </div>
      </div>
      <div className='container-armon'>
        <div className='row ligas-list-row'>
          {ligas_item.map((item, index) => {
            const isOpen = expandedItem === item.ligas_item_nombre;
            const isPimus = item.ligas_item_nombre === '° PIMUS';

            if (isPimus) {
              return (
                <div key={index} className='col-12 ligas_item ligas-item-block pimus-wrapper'>
                  <button
                    type='button'
                    className='pimus-trigger'
                    onClick={() => toggleItem(item.ligas_item_nombre)}
                  >
                    <span className='ligas-bullet'>◦</span>
                    <span>PIMUS</span>
                  </button>

                  {isOpen && (
                    <div className='pimus-links'>
                      {item.ligas_item_children.map((child, childIndex) => (
                        <a
                          key={childIndex}
                          href={child.ligas_item_url}
                          target='_blank'
                          rel='noreferrer'
                          className='pimus-link'
                        >
                          <span className='ligas-pdf-icon'>📄</span>
                          <span>{child.ligas_item_nombre}</span>
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <div key={index} className='col-12 ligas_item ligas-item-block' style={{ marginBottom: '0.5rem' }}>
                <Link to={item.ligas_item_url}>{item.ligas_item_nombre}</Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Ligas;





